import axios from 'axios'
import { EventTypes } from 'redux-segment'

export function getDefaultDataViewDashboard() {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_DASHBOARD_DEFAULT_FETCH',
      payload: axios('/data_view_dashboards/default')
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/DataViewDashboardActions.js